import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { TextDiff } from '../fplusDiff/TextDiff'
import { useHideInheritanceDiff } from './useHideInheritanceDiff'

type Props = {
  current: Optional<string>
  compare: Optional<string>
}

/**
 * Documentation is prose, and prose that runs to more than a line changes the
 * way any other body of text does: a word here, a sentence there. It is read as
 * a diff for the same reason an expression is — so a reader finds what changed
 * instead of two paragraphs to compare by eye.
 */
export const ComparableDocumentationDiff = ({ current, compare }: Props) => {
  const translate = useTranslate()
  const isHidingInheritanceDiff = useHideInheritanceDiff(current)

  if (isHidingInheritanceDiff) {
    return null
  }

  return (
    <TextDiff
      title={translate('diffPopover.field.documentation')}
      compare={compare}
      current={current}
    />
  )
}
